import React from 'react';
import Button from 'kingpin/atoms/Button';

import PopupStyles from '../../MetricPicker/MetricPickerPopup/PopupStyles';
import Row from '../../../Common/Row';
import Typography from 'kingpin/atoms/Typography';

const SelectedFields = ({
  selectedFieldsCount,
}: {
  selectedFieldsCount: number;
}) => (
  <Row centerAlign style={{ marginRight: 24 }}>
    <Typography.Body type="Body 12">Selected Field(s):</Typography.Body>
    <Typography.Body type="Body 12">{`${selectedFieldsCount} Fields`}</Typography.Body>
  </Row>
);

const BottomBar = ({
  isConfirmEnabled,
  onCancelClicked,
  selectedFieldsCount,
  onConfirmClicked,
  isSaving,
  onClearClicked,
  applyOnChange,
}: {
  selectedFieldsCount: number;
  isConfirmEnabled: boolean;
  onConfirmClicked: () => void;
  onCancelClicked: () => void;
  isSaving?: boolean;
  onClearClicked?: () => void;
  applyOnChange?: boolean;
}) => (
  <PopupStyles.PopupContent.BottomBarDiv centerAlign spaceBetween>
    <Row centerAlign style={{ gap: 8 }}>
      <Button
        onClick={onCancelClicked}
        label={applyOnChange ? 'Done' : 'Cancel'}
        type="Tertiary"
        size="Small"
      />
      {onClearClicked && (
        <Button
          onClick={onClearClicked}
          label="Clear all"
          type="Tertiary"
          size="Small"
          isDisabled={selectedFieldsCount === 0}
        />
      )}
    </Row>
    <Row centerAlign>
      <SelectedFields selectedFieldsCount={selectedFieldsCount} />
      {!applyOnChange && (
        <Button
          onClick={onConfirmClicked}
          label="Confirm Selection"
          isDisabled={!isConfirmEnabled}
          isLoading={isSaving}
          type="Primary"
          size="Small"
        />
      )}
    </Row>
  </PopupStyles.PopupContent.BottomBarDiv>
);

export default BottomBar;
